import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import Time from '../../Time';
import PayrollScreenShots from '../payroll/PayrollScreenShots';
import RequestTimeAjust from './UserRequestTimeAjust';
import '../../css/App.css'
import '../../css/bootstrap.min.css';
import bootstrap from 'bootstrap'
const axios = require('axios').default;

class TimeSheetRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      payrollList:[],
      totalHours:"",
      seeScreenshots:false,
      ajustRequest:false,
    };

    this.handleChange = this.handleChange.bind(this)
    this.getScreenshots = this.getScreenshots.bind(this)
    this.openCloseAjustWindow = this.openCloseAjustWindow.bind(this)
  }

  //Opens and closes the Screenshot window
  getScreenshots = () =>{
    let windowScreenShots = this.state.seeScreenshots;      
    this.setState({seeScreenshots:!windowScreenShots})
  }
  

  componentDidMount = () =>{
    //Calculate how many hours the user worked in that time
    //Caclulation based on the times user inputed
    let startTime = new Date(this.props.StartTime);
    let endTime = new Date(this.props.EndTime);

    let hoursCalculated = endTime - startTime

    let hoursResult = Time.convertSecondsToString(hoursCalculated/1000)

    if(hoursResult == "NaN:NaN:NaN"){
      hoursResult = "Shift not completed"
    }

    this.setState({totalHours:hoursResult})


  }
 
  openCloseAjustWindow = () =>{
    let window = this.state.ajustRequest;
    this.setState({ajustRequest:!window})
  }

  updateAll = () =>{
    this.props.updateRows();
  }

  handleChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  render() {

    //Give Conditions to show the Screenshot window to the user
    let screenShotWindow;
    if(this.state.seeScreenshots){
      screenShotWindow = 
      <PayrollScreenShots
        id={this.props.Id}
        close={this.getScreenshots}
      />
    }

    //Give Conditions to show the Time change request window to the user
    let requestTimeChangeWindow;
    if(this.state.ajustRequest){
      requestTimeChangeWindow = 
      <RequestTimeAjust
        update={this.updateAll}
        close={this.openCloseAjustWindow}
        startTime={this.props.OriginalStartTime}
        endTime={this.props.OriginalEndTime}
        id={this.props.Id}
      />
    }
    

    return(
      <tr>
        <td>{this.props.Id}</td>
        <td>{this.props.Username}</td>
        <td>{this.props.OriginalStartTime}</td>
        <td>{this.props.OriginalEndTime}</td>
        <td>{this.props.StartTime}</td>
        <td>{this.props.EndTime}</td>
        <td>{this.props.BreakMinutes}</td>
        <td>{this.props.UserVerified}</td>
        <td><button onClick={this.openCloseAjustWindow}>Request Ajustment</button></td>
        <td>{this.props.FlagReason}</td>
        <td>{this.state.totalHours}</td>
        <td>{this.props.WorkLocation}</td>
        <td><button onClick={this.getScreenshots}>See Screenshots</button></td>
        {screenShotWindow}
        {requestTimeChangeWindow}
      </tr>
    );
  }
}

export default TimeSheetRow;